export default {
  aesHexKey: '603deb1015ca71be2b73aef0857d161119922c073b6108d72d9810a30914dff4',
  user: {
    role: null,
    portal: null,
    custname: null,
    token: null,
    name: null,
    email: null
  }
};
